import PointOfInterestUI from './PointOfInterestUI';
import SearchUI from './SearchUI';
import OpacitySlider from './OpacitySlider';
import MapTitle from './MapTitle';
import AdminControls from './AdminControls';
import { debugMode } from '../model/StaticVariables';

export default function ViewControls(props) {
    const { type } = props;
    const tab = type.label.toLowerCase();
    if (tab === 'more info') return null;
    //overall_svi
    return (
        <div id="view-controls" aria-label={'Display Controls'} role="toolbar" className="control">
            <div className="grid-wrap">
                <MapTitle />
                {tab === 'map' && (
                    <>
                        <PointOfInterestUI />
                        <OpacitySlider />
                        <SearchUI />
                        {debugMode && <AdminControls />}
                    </>
                )}
            </div>
        </div>
    );
}
